import ko from "knockout";

ko.extenders.trackChange = function (target) {
    const original = ko.observable(target());

    target.isDirty = ko.pureComputed(function () {
        return target() !== original();
    });

    target.reset = function () {
        target(original());
    };

    target.commit = function () {
        original(target());
    };

    return target;
};
